module.exports = __webpack_public_path__ + "img/output_suggestion.0bcbfd5a.png";